import { FC, HTMLAttributes } from 'react';

type BraveBrowserProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const BraveBrowser: FC<BraveBrowserProps> = ({ size = 16, ...props }) => {
  const aspectRatio = 0.875;
  const width = size;
  const height = width / aspectRatio;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 56 64"
      {...props}
    >
      <path
        fill="url(#paint0_linear)"
        fillRule="evenodd"
        d="m53.292 15.321 1.5-3.676s-1.909-2.043-4.227-4.358c-2.317-2.315-7.225-.953-7.225-.953L37.751 0H18.12l-5.589 6.334s-4.908-1.362-7.225.953C2.988 9.602 1.08 11.645 1.08 11.645l1.5 3.676-1.91 5.447s5.614 21.236 6.272 23.83c1.295 5.106 2.181 7.08 5.862 9.668s10.36 7.08 11.45 7.762c1.091.68 2.455 1.84 3.682 1.84s2.59-1.16 3.68-1.84 7.77-5.175 11.452-7.762c3.68-2.587 4.567-4.562 5.862-9.668.657-2.594 6.27-23.83 6.27-23.83z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M34.888 11.508c.818 0 6.885-1.157 6.885-1.157s7.189 8.68 7.189 10.536c0 1.534-.619 2.134-1.347 2.842-.152.148-.31.3-.467.468l-5.39 5.717-.176.18c-.538.54-1.33 1.336-.772 2.658l.115.269c.613 1.432 1.37 3.2.407 4.99-1.025 1.906-2.78 3.178-3.905 2.967s-3.766-1.589-4.737-2.218c-.971-.63-4.05-3.166-4.05-4.137 0-.809 2.214-2.155 3.29-2.81.214-.13.383-.232.48-.298.111-.075.297-.19.526-.332.981-.61 2.754-1.71 2.799-2.197.055-.602.034-.778-.758-2.264-.168-.316-.365-.654-.568-1.004-.754-1.295-1.598-2.745-1.41-3.784.21-1.173 2.05-1.845 3.608-2.415q.292-.105.567-.209l1.623-.609c1.556-.582 3.284-1.229 3.57-1.36.394-.181.292-.355-.903-.468l-.58-.06c-1.48-.157-4.209-.446-5.535-.077-.261.073-.553.152-.86.235-1.49.403-3.317.897-3.493 1.182q-.045.074-.089.133c-.168.238-.277.394-.091 1.406.055.302.169.895.31 1.629.41 2.148 1.053 5.498 1.134 6.25q.017.159.036.305c.103.84.171 1.399-.805 1.622l-.255.058c-1.102.252-2.717.623-3.3.623-.584 0-2.2-.37-3.302-.623l-.254-.058c-.976-.223-.907-.782-.804-1.622q.018-.147.035-.305c.081-.753.725-4.112 1.137-6.259.14-.73.253-1.32.308-1.62.185-1.012.076-1.168-.092-1.406l-.09-.133c-.174-.285-2-.779-3.491-1.182-.307-.083-.6-.162-.86-.235-1.327-.37-4.055-.08-5.535.077q-.341.037-.58.06c-1.196.113-1.297.287-.903.468.285.131 2.013.778 3.568 1.36.597.223 1.17.437 1.624.609q.275.103.568.21c1.558.57 3.398 1.241 3.608 2.414.187 1.039-.657 2.489-1.41 3.784-.204.35-.4.688-.569 1.004-.791 1.486-.812 1.662-.757 2.264.044.488 1.816 1.587 2.798 2.197.229.142.415.257.526.332.098.066.266.168.48.298 1.076.654 3.29 2 3.29 2.81 0 .97-3.078 3.507-4.05 4.137-.97.63-3.612 2.008-4.737 2.218s-2.88-1.061-3.904-2.966c-.963-1.791-.207-3.559.406-4.99l.115-.27c.559-1.322-.233-2.118-.772-2.658l-.175-.18-5.39-5.717c-.158-.167-.316-.32-.468-.468-.728-.707-1.346-1.308-1.346-2.842 0-1.855 7.189-10.536 7.189-10.536s6.066 1.157 6.884 1.157c.653 0 1.913-.433 3.227-.885.333-.114.669-.23 1-.34 1.635-.545 2.726-.549 2.726-.549s1.09.004 2.726.549c.33.11.667.226 1 .34 1.313.452 2.574.885 3.226.885m-1.041 30.706c1.282.66 2.192 1.128 2.536 1.343.445.278.174.803-.232 1.09-.405.285-5.853 4.499-6.381 4.965l-.215.191c-.509.459-1.159 1.044-1.62 1.044-.46 0-1.11-.586-1.62-1.044l-.213-.191c-.53-.466-5.977-4.68-6.382-4.966s-.677-.81-.232-1.09c.344-.214 1.255-.683 2.539-1.344l1.22-.629c1.92-.992 4.315-1.837 4.689-1.837s2.767.844 4.689 1.837q.655.34 1.222.63z"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint1_linear)"
        fillRule="evenodd"
        d="M43.34 6.334 37.751 0H18.12l-5.589 6.334s-4.908-1.362-7.225.953c0 0 6.544-.59 8.793 3.064 0 0 6.066 1.157 6.884 1.157s2.59-.68 4.226-1.225 2.727-.549 2.727-.549 1.09.004 2.726.549 3.408 1.225 4.226 1.225 6.885-1.157 6.885-1.157c2.249-3.654 8.792-3.064 8.792-3.064-2.317-2.315-7.225-.953-7.225-.953"
        clipRule="evenodd"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0.671"
          x2="55.2"
          y1="64.319"
          y2="64.319"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F50"></stop>
          <stop offset="0.41" stopColor="#F50"></stop>
          <stop offset="0.582" stopColor="#FF2000"></stop>
          <stop offset="1" stopColor="#FF2000"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="6.278"
          x2="50.565"
          y1="11.466"
          y2="11.466"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF452A"></stop>
          <stop offset="1" stopColor="#FF2000"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BraveBrowser;
